import { BANK_ID, MANUAL_OCR } from 'Router/routes';
import { IdentificationStatusProps } from './types';

const identityStatusMap = (
  isCZResident: boolean,
): Record<string, IdentificationStatusProps> => ({
  REQUESTED: {
    type: 'warning',
    title: 'welcome_back:identity_requested.title',
    description: 'welcome_back:identity_requested.description',
    navigateTo: BANK_ID,
    statusType: 'identityStatus',
  },
  OCR_IN_PROGRESS: {
    type: 'waiting',
    title: 'welcome_back:identity_ocr_in_progress.title',
    description: 'welcome_back:identity_ocr_in_progress.description',
    statusType: 'identityStatus',
  },
  OCR_MANUAL_CHECK_NEEDED: {
    type: 'waiting',
    title: 'welcome_back:identity_manual_check_needed.title',
    description: 'welcome_back:identity_manual_check_needed.description',
    statusType: 'identityStatus',
  },
  OCR_WRONG_DOCUMENT: {
    type: 'warning',
    title: 'welcome_back:identity_ocr_wrong_document.title',
    description: 'welcome_back:identity_ocr_wrong_document.description',
    navigateTo: BANK_ID,
    statusType: 'identityStatus',
  },
  APPROVED: {
    type: 'success',
    title: 'welcome_back:identity_approved.title',
    statusType: 'identityStatus',
  },
  BANKID_IN_PROGRESS: {
    type: 'warning',
    title: isCZResident
      ? 'welcome_back:identity_bank_id_in_progress.title'
      : 'welcome_back:identity_bank_id_in_progress_no_cz.title',
    description: isCZResident
      ? 'welcome_back:identity_bank_id_in_progress.description'
      : 'welcome_back:identity_bank_id_in_progress_no_cz.description',
    navigateTo: BANK_ID,
    statusType: 'identityStatus',
  },
  BANKID_ERROR: {
    type: 'warning',
    title: isCZResident
      ? 'welcome_back:identity_bank_id_error.title'
      : 'welcome_back:identity_bank_id_error_no_cz.title',
    description: isCZResident
      ? 'welcome_back:identity_bank_id_error.description'
      : 'welcome_back:identity_bank_id_error_no_cz.description',
    navigateTo: MANUAL_OCR,
    statusType: 'identityStatus',
  },
  BANKID_DATA_MISMATCH: {
    type: 'warning',
    title: isCZResident
      ? 'welcome_back:identity_bank_id_data_mismatch.title'
      : 'welcome_back:identity_bank_id_data_mismatch_no_cz.title',
    description: isCZResident
      ? 'welcome_back:identity_bank_id_data_mismatch.description'
      : 'welcome_back:identity_bank_id_data_mismatch_no_cz.description',
    navigateTo: MANUAL_OCR,
    statusType: 'identityStatus',
  },
  BANKID_REJECTED: {
    type: 'warning',
    title: 'welcome_back:identity_bank_id_rejected.title',
    description: 'welcome_back:identity_bank_id_rejected.description',
    navigateTo: MANUAL_OCR,
    statusType: 'identityStatus',
  },
  BANKID_REJECTED_BY_CLIENT: {
    type: 'warning',
    title: isCZResident
      ? 'welcome_back:identity_bank_id_rejected_by_client.title'
      : 'welcome_back:identity_bank_id_rejected_by_client_no_cz.title',
    description: isCZResident
      ? 'welcome_back:identity_bank_id_rejected_by_client.description'
      : 'welcome_back:identity_bank_id_rejected_by_client_no_cz.description',
    navigateTo: MANUAL_OCR,
    statusType: 'identityStatus',
  },
});

export default identityStatusMap;
